import _set from 'lodash/set';

import { MutationTree } from "vuex";
import { PropertiesState } from "./types";
import { Property } from "@/models";
import _ from 'lodash';

/**
 * Mutations
 *
 * The only way to actually change state in a Vuex store is by committing a mutation.
 * - Vuex mutations are very similar to events: each mutation has a string type and a handler.
 * - The handler function is where we perform actual state modifications - it receives the state as the first argument:
 * - You cannot directly call a mutation handler.
 * - Think of it more like event registration: "When a mutation with type X is triggered, call this handler."
 * - To invoke a mutation handler, you need to call store.commit with its type e.g. `store.commit('setUser', user)`
 */
 export const mutations: MutationTree<PropertiesState> = {

	/**
	 * Set the Propertys list
	 * 
	 * @param {PropertiesState} state
	 * @param {Property[]} Propertys
	 * @returns void
	 */
	 setPropertys(state: PropertiesState, Propertys: Property[]): void {
		state.list = Propertys;
	},

	/**
	 * Set current Property
	 * 
	 * @param {PropertiesState} state
	 * @param {Property} Property
	 * @returns void
	 */
	 setCurrent(state: PropertiesState, Property: Property): void {
		state.current = Property;
	},

	/**
   * Set current page
   *
   * @param state ReportsState
   * @param currentPage number
   * @returns void
   */
  setCurrentPage(state: PropertiesState, currentPage: number): void {
    state.currentPage = currentPage;
  },

	/**
	 * Set the currently edited/viewed Property
	 */
	setPropertiesDeep(state: PropertiesState, payload: {path: string, data: any}): void {
    state.current = Object.assign(new Property, _set(state.current, payload.path, payload.data));
  },

	/**
	 * ++ Unsaved changes
	 * 
	 * @param state PropertiesState
	 * @param element string
	 * @returns void
	 */
	 addUnsavedChange(state: PropertiesState, element: string): void {
		state.updates = [...new Set(state.updates.concat([element]))];
	},

	/**
 	* Reset Unsaved changes
 	* 
 	* @param state PropertiesState
 	* @returns void
 	*/
	 resetUnsavedChanges(state: PropertiesState): void {
		state.updates = [];
	},

	resetState(state: PropertiesState): void {
		state.current = new Property;
		state.list = [];
		state.updates = [];
	},

	rehydrateState(state: PropertiesState): void {
    state.current = new Property(state.current);
		state.list = state.list.map((x: any) => new Property(x));
  }

 }
